export default function getServerBaseUrl() {
  const explicitApiUrl = process.env.REACT_APP_API_URL;
  if (explicitApiUrl) {
    return explicitApiUrl.replace(/\/$/, "");
  }

  const socketUrl = process.env.REACT_APP_SOCKET_URL;
  if (socketUrl && socketUrl !== "/") {
    return socketUrl.replace(/\/$/, "");
  }

  const { protocol, hostname, port, origin } = window.location;
  if (
    (hostname === "localhost" || hostname === "127.0.0.1") &&
    (port === "3000" || port === "")
  ) {
    return `${protocol}//${hostname}:3001`;
  }

  return origin;
}